<template>
  <div>
    <b-form-group
      class="mb-3"
      id="email"
      label-for="input-email"
      :invalid-feedback="inputInvalid"
      :label="label"
      :class="col"
    >
      <b-form-input
        id="input-email"
        v-model="email"
        :placeholder="inputText"
        :state="state"
        :disabled="disabled"
        @blur="validacaoEmail(email)"
        autocomplete="off"
        trim
      >
      </b-form-input>
    </b-form-group>
  </div>
</template>

<script>
export default {
  props: {
    label: String, // para dar nome ao campo
    inputText: String, // placeholder
    inputInvalid: String, // mensagem para campo invalido
    col: String, // definindo o tamanho do input na tela de acordo com cada caso
    disabled: Boolean, //para abilitar ou desabilitar o campo
    filtro: String, // envia dados do componente pai para o filho
    validado: Boolean, // controla a cor dos campos
  },

  created() {
    if (this.filtro) {
      this.email = this.filtro;
    }
  },

  computed: {
    state() {
      if (
        (this.validado || this.validado === false) &&
        (this.estado === null ||
          this.estado === false ||
          this.estado === true) &&
        this.email.length != 0
      ) {
        return this.validado;
      }
      return this.estado;
    },
  },

  data() {
    return {
      email: "",
      usuario: "",
      dominio: "",
      estado: null,
    };
  },

  methods: {
    validacaoEmail(email) {
      if (email.length === 0) {
        // o campo só ira pintar se tiver algo no input
        this.estado = null;
        return;
      }
      this.usuario = email.substring(0, email.indexOf("@"));
      this.dominio = email.substring(email.indexOf("@") + 1, email.length);

      if (
        this.usuario.length >= 1 &&
        this.dominio.length >= 3 &&
        this.usuario.search("@") == -1 &&
        this.dominio.search("@") == -1 &&
        this.usuario.search(" ") == -1 &&
        this.dominio.search(" ") == -1 &&
        this.dominio.search(".") != -1 &&
        this.dominio.indexOf(".") >= 1 &&
        this.dominio.lastIndexOf(".") < this.dominio.length - 1
      ) {
        this.$emit("emitindoEmail", this.email);
        this.estado = true;
      } else {
        if (this.email.length === 0) {
          // verificando novamente o input para pintar o campo
          this.estado = null;
        } else {
          // se já estiver com dados no input e não estiver válido ira pintar de vermelho
          this.estado = false;
        }
      }
    },
    limpar() {
      this.email = "";
      this.estado = null;
    },
  },
};
</script>

